/**
 * Created by shakibuz.zaman on 5/19/2020.
 */
export class DataSurveyFieldConfigKeys {
  static readonly ArrangmentAEFieldConfigKey = 'DataSurvey-Arrangement-Associate-Enterprises-Config'
}
